import { AfterViewInit, Component, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

import { BaseUI } from '../base.ui';
import { ParentEvents } from '../../utils/parent-events.service';

import { environment } from '../../../../environments/environment';

@Component({
    template: ``,
})
export class BaseDialog extends BaseUI implements AfterViewInit, OnDestroy {
    public isClientPortal = environment.portalClient;

    constructor(parentEvents: ParentEvents, private el: ElementRef, private renderer: Renderer2) {
        super(parentEvents);
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();

        if (!this.isClientPortal) {
            setTimeout(() => {
                const iframe = window.parent.document.querySelector('iframe');
                const modalWrapperEl = this.el.nativeElement.closest('.cdk-global-overlay-wrapper');
                const modalPaneEl = this.el.nativeElement.closest('.cdk-overlay-pane');

                if (iframe && modalWrapperEl && modalPaneEl) {
                    const paddingTop =
                        window.parent.scrollY -
                        (iframe ? iframe.offsetTop : 0) +
                        window.parent.innerHeight / 2 -
                        modalPaneEl.offsetHeight / 2;

                    this.renderer.setStyle(modalWrapperEl, 'align-items', 'flex-start');
                    this.renderer.setStyle(modalWrapperEl, 'padding-top', paddingTop + 'px');
                }
            }, 1);
        }
    }
}
